<template>
  <div class="ba-analysis">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            告警事件分析
          </div>
          <div class="tip">
            可在此查詢告警紀錄分析
          </div>
        </div>
      </div>
      <div class="content">
        <!-- Filter -->
        <FilterFrame
          ref="filter"
          :filter-form="outputAnalysisFilterStructure"
          class="filter-frame"
          @search="search"
          @clear="clearSearch()"
          @change="change"
        />
        <!-- Chart -->
        <h3 v-if="outputChartData">
          此設備正常/異常比率
        </h3>
        <div
          v-if="outputChartData"
          class="chart-container"
        >
          <div
            v-for="[key, value] in Object.entries(outputChartData)"
            :key="key"
            class="period"
          >
            <div
              class="chart-wrapper"
              :style="{height: chartHeightWithOffset + 'px'}"
            >
              <Doughnut
                class="chart"
                :period="PeriodStructure[key]"
                :style="`height:${chartHeight}`"
                :height="chartHeight"
                :chart-data="value.Doughnut"
              />
            </div>
            <div
              class="chart-wrapper"
              :style="{height: chartHeightWithOffset + 'px'}"
            >
              <h3>此設備本{{ PeriodStructure[key] }}各點位異常次數</h3>
              <Bar
                class="chart"
                :period="PeriodStructure[key]"
                :style="`height:${chartHeight}`"
                :height="chartHeight"
                :chart-data="value.Bar"
              />
            </div>
            <div
              v-if="key !== 'day'"
              class="chart-wrapper"
              :style="{height: chartHeightWithOffset + 'px'}"
            >
              <h3>此設備本{{ PeriodStructure[key] }}各點位異常趨勢分析</h3>
              <LineChart
                class="chart"
                :period="PeriodStructure[key]"
                :style="`height:${chartHeight}`"
                :height="chartHeight"
                :chart-data="value.Line"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Doughnut from './components/chart/Doughnut.vue'
import Bar from './components/chart/Bar.vue'
import LineChart from './components/chart/LineChart.vue'
import { processAnalysisData, processFilterOptions } from './utils'
import { analysisFilterStructure } from './models'
import FilterFrame from '../../components/FilterFrame.vue'
// 本日（當日 00:00 - 現在）
// 本週（當週一 00:00 - 現在）
// 本月（當月一號 00:00 - 現在）
// 本年（當年 1/1 00:00 - 現在）
export default {
  components: {
    FilterFrame,
    Doughnut,
    Bar,
    LineChart
  },
  data () {
    const chartType = ['Doughnut', 'Bar', 'Line']
    const periodZh = ['日', '週', '月', '年']
    const period = ['day', 'week', 'month', 'year']
    const PeriodStructure = {
      day: '日',
      week: '週',
      month: '月',
      year: '年'
    }
    const outputChartData = null
    const chartHeight = 250
    // 小螢幕下標題會換行造成下方圖表需要 scroll 才能看見全貌
    const chartHeightWithOffset = chartHeight + 110
    const outputAnalysisFilterStructure = [...analysisFilterStructure]
    const defaultReq = {
      IntervalList: [0, 1, 2, 3]
    }
    const req = defaultReq
    return {
      outputAnalysisFilterStructure,
      chartHeight,
      chartHeightWithOffset,
      PeriodStructure,
      periodZh,
      period,
      outputChartData,
      chartType,
      defaultReq,
      req
    }
  },
  async mounted () {
    // 圖表是 by 設備名稱，一開始沒填設備名稱則不該有圖表
    this.getAssetsNameList()
  },
  destroyed () {
  },
  methods: {
    async getAssetsNameList () {
      try {
        const assetsRes = await apiAsset.Asset.getAssetsAbridgedList()
        const assetsData = assetsRes.data
        // 因部分資產不屬於 ba 設備，無 BaDeviceId，因此過濾掉
        const assetsDataBaOnly = assetsData.filter(el => el.BaDeviceId)
        const assetsOptions = assetsDataBaOnly.map(el => ({
          label: el.AssetName,
          value: el.BaDeviceId
        }))
        // TODO: 轉為用 filter 以名字取得並直接操作該物件
        // 清空點位
        this.outputAnalysisFilterStructure[1].isDisable = true
        this.outputAnalysisFilterStructure[1].value = []
        // 填入設備
        this.outputAnalysisFilterStructure[0].options = assetsOptions
        this.outputAnalysisFilterStructure[0].isDisable = false
      } catch (error) {
        console.log(error)
      }
    },
    async getTagNameList (value) {
      try {
        // TODO: 正翰給點位 API 的話要替換掉
        const assetsRes = await apiBaAlert.getTagListFromBaDevice(value)
        const assetsData = assetsRes.data
        const assetsOptions = assetsData.map(el => ({
          label: el.Name,
          value: el.Id
        }))
        // 填入點位
        this.outputAnalysisFilterStructure[1].options = assetsOptions
        this.outputAnalysisFilterStructure[1].isDisable = false
      } catch (error) {
        console.log(error)
      }
    },
    async initChartData () {
      const intervalList = this.req.IntervalList
      // 取資料要使用初始資料來喚起 loading 畫面
      const loadingByIntervalList = () => {
        let tempChartData = {}
        const emptyTypes = {
          Doughnut: null,
          Bar: null,
          Line: null
        }
        intervalList.forEach(interval => {
          const key = this.period[interval]
          tempChartData = {
            ...tempChartData,
            [key]: emptyTypes
          }
        })
        this.outputChartData = tempChartData
      }
      loadingByIntervalList()
      // 實際串接
      try {
        const res = await apiBaAlert.getAnalysis(this.req)
        await this.$sleep(1000, res.duration)
        if (!res || !res.data || !Array.isArray(res.data) || res.data.length === 0) {
          throw new Error('無此資料')
        }
        this.outputChartData = processAnalysisData(res.data)
      } catch (error) {
        console.log(error)
        this.outputChartData = null
        this.$confirm(error.message, {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        }).finally(() => {
        })
      }
    },
    search (filterOptions) {
      this.req = processFilterOptions(filterOptions, this.defaultReq)
      this.initChartData()
    },
    clearSearch () {
      this.outputChartData = null
    },
    change (index, value) {
      if (index === 0) {
        this.getTagNameList(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-analysis {
  @include mainLayer();
  ::v-deep .emergency {
    color: $dangerColor;
  }
  h3 {
    // align-self: start;
    font-size: 21px;
    color: $mainFontColor;
    padding-bottom: 20px;
  }
  .content {
    width: 100%;
    .filter-frame {
      width: 100%;
    }
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  .chart-container {
    width: 100%;
    display: flex;
    .period {
      width: 25%;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .chart-wrapper {
        // flex: 1 1 100%;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 0;
      }
    }
  }
}
</style>
